export default __webpack_public_path__ + "clock.480d0c1e19280dba.svg";